"use client";

import type { ReactNode } from "react";
import type { LeadFlowThemeContrast } from "../types";

import { Button } from "@homeinstead/ui/components/Button";
import { getButtonVariant } from "../utils/get-button-variant";

const DEFAULT_CTA_LABEL = "Get started";

type LauncherProps = {
  ctaLabel: string | null;
  ctaSublabel: string | null;
  /** Section content leading the call to action. */
  header?: ReactNode;
  onOpen: () => void;
  /** The contrast of the section the call to action sits on. */
  themeContrast: LeadFlowThemeContrast;
};

/** The call to action a `launcher` entry shows until the flow is opened. */
function Launcher({
  ctaLabel,
  ctaSublabel,
  header,
  onOpen,
  themeContrast,
}: LauncherProps) {
  const launcher = (
    <div className="flex flex-col items-start gap-2" data-lead-flow-launcher="">
      <Button
        className="w-full sm:w-auto"
        onClick={onOpen}
        type="button"
        variant={getButtonVariant(themeContrast)}
      >
        {ctaLabel || DEFAULT_CTA_LABEL}
      </Button>
      {ctaSublabel ? <p className="text-sm">{ctaSublabel}</p> : null}
    </div>
  );

  return header ? (
    <div className="flex flex-col gap-5">
      {header}
      {launcher}
    </div>
  ) : (
    launcher
  );
}

export { Launcher };
